"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HousePrinting = void 0;
var Tags_1 = require("../Tags");
var CardType_1 = require("../CardType");
var Resources_1 = require("../../Resources");
var Card_1 = require("../Card");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var Units_1 = require("../../Units");
var HousePrinting = (function (_super) {
    __extends(HousePrinting, _super);
    function HousePrinting() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.HOUSE_PRINTING,
            tags: [Tags_1.Tags.BUILDING],
            cost: 10,
            productionBox: Units_1.Units.of({ steel: 1 }),
            metadata: {
                cardNumber: 'P36',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.steel(1); });
                }),
                description: 'Increase your steel production 1 step.',
                victoryPoints: 1,
            },
        }) || this;
    }
    HousePrinting.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.STEEL, 1);
        return undefined;
    };
    HousePrinting.prototype.getVictoryPoints = function () {
        return 1;
    };
    return HousePrinting;
}(Card_1.Card));
exports.HousePrinting = HousePrinting;
